import {useEffect, useState, useRef } from "react";

function VoiceIndicator({ size, bgColor }) {
  const range = Array.from({ length: 3 }, (_, index) => index + 1);
  return <div className="flex flex-row gap-2">
    {range.map((key) => (
        <div
            key={key}
            className="rounded-full transition-all"
            style={{ width: size, height: size, backgroundColor: bgColor }}
        ></div>
    ))}
  </div>

}

export default function ReadingIn({ minimiz }) {
  const [audioSource, setAudioSource] = useState();
  const analyserRef = useRef(null);
  const mediaElementSource = useRef(null);
  let animationFrameId = useRef(null);

  const [readerVoiceIndicatorSize, setReaderVoiceIndicator] = useState(50); // Default size
  const [readerVoiceIndicatorBgColor, setReaderVoiceIndicatorBgColor] = useState('gray'); // Default color

  const mimicVoiceIndicatorAnimation = () => {
    // Simple mimic animation logic
    const newSize = Math.random() * 50 + (minimiz? 20: 50); // Random size between 100 and 200
    const grayValue = Math.floor(Math.random() * 500);
    const newBgColor = `rgb(${grayValue}, ${grayValue}, ${grayValue})`;

    setReaderVoiceIndicator(newSize);
    setReaderVoiceIndicatorBgColor(newBgColor);

    animationFrameId.current = requestAnimationFrame(mimicVoiceIndicatorAnimation);
  };

  useEffect(() => {
    animationFrameId.current = requestAnimationFrame(mimicVoiceIndicatorAnimation);
    return ()=> {
      if (mediaElementSource.current) {
        mediaElementSource.current.disconnect();
        mediaElementSource.current = null;
      }

      if (analyserRef.current) {
        analyserRef.current.disconnect();
        analyserRef.current = null;
      }

      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current);
      }
    }
  }, []);

  return (
      <div>
        <VoiceIndicator size={readerVoiceIndicatorSize} bgColor={readerVoiceIndicatorBgColor} />
      </div>
  );
}